import React__default from 'react';
import { NumericFormat } from 'react-number-format';
import BigNumber from 'bignumber.js';
import { ValueIndicator, Indicator } from './styles.js';
import { useTheme, Tooltip, Box, Typography } from '@mui/material';
import { isNil } from 'lodash-es';
import { formatCompactNumber } from '../../../../../utils/numbers.js';

var adjustDecimals = function (value, decimals) {
    var decimalPart = value.abs().mod(1);
    if (decimals == 1) {
        if (decimalPart.gt(0.95))
            return 0;
        else if (decimalPart.lt(0.05))
            return 0;
    }
    return decimals;
};
var adjustNumber = function (value, decimals, hideNegativeSign) {
    if (decimals === 1 && value.lt(0) && value.gte(-0.05))
        return 0;
    if (hideNegativeSign)
        return value.abs();
    return value;
};
var ChangeIndicator = function (_a) {
    var id = _a.id, _b = _a.value, value = _b === void 0 ? "0" : _b, label = _a.label, _c = _a.type, type = _c === void 0 ? "graph" : _c, _d = _a.normalized, normalized = _d === void 0 ? false : _d, _e = _a.stableCoinOperative, stableCoinOperative = _e === void 0 ? false : _e, sx = _a.sx, tooltip = _a.tooltip, _f = _a.decimalScale, decimalScale = _f === void 0 ? stableCoinOperative ? 2 : 8 : _f, _g = _a.smallPct, smallPct = _g === void 0 ? true : _g, _h = _a.indicatorPostion, indicatorPostion = _h === void 0 ? "left" : _h, _j = _a.shorten, shorten = _j === void 0 ? false : _j;
    var bigNumberValue = new BigNumber(value);
    if (normalized)
        bigNumberValue = bigNumberValue.multipliedBy(100);
    var isPositiveValue = bigNumberValue.isPositive();
    var theme = useTheme();
    var isFinite = Number.isFinite(+value || 0);
    var renderIndicator = function () {
        var isZero = bigNumberValue.isZero();
        var color = isZero
            ? theme.palette.neutral300
            : isPositiveValue
                ? theme.palette.green
                : theme.palette.red;
        var hideNegativeSign = type === "graph" && indicatorPostion === "left";
        var adjustedValue = shorten
            ? formatCompactNumber(hideNegativeSign ? Math.abs(+value) : value, 2)
            : adjustNumber(bigNumberValue, decimalScale, hideNegativeSign).toFixed();
        var suffix = type === "only_number" || smallPct ? "" : "%";
        if (shorten) {
            var lastChar = adjustedValue.slice(-1);
            if (isNaN(Number(lastChar))) {
                suffix = lastChar + suffix;
                adjustedValue = adjustedValue.slice(0, -1);
            }
        }
        return (React__default.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center" },
            React__default.createElement(ValueIndicator, { variant: type === "graph" ? "body2" : "body1", color: color, smallPct: smallPct && type !== "only_number" && !isNil(value), sx: sx, whiteSpace: "nowrap", id: id && "".concat(id, "-wrapper") },
                !isZero && type === "graph" && indicatorPostion === "left" && (React__default.createElement(Indicator, { isPositive: isPositiveValue, preserveAspectRatio: "none" })),
                isFinite ? (React__default.createElement(NumericFormat, { value: adjustedValue, displayType: "text", suffix: suffix, thousandSeparator: ",", decimalScale: adjustDecimals(bigNumberValue, decimalScale), fixedDecimalScale: stableCoinOperative, id: id })) : (React__default.createElement("span", null, "∞")),
                !isZero && type === "graph" && indicatorPostion === "right" && (React__default.createElement(Indicator, { isPositive: isPositiveValue, preserveAspectRatio: "none" })))));
    };
    return (React__default.createElement(Tooltip, { title: tooltip },
        React__default.createElement(Box, { justifyContent: "center" }, !isNaN(+value) ? (React__default.createElement(React__default.Fragment, null,
            renderIndicator(),
            label && (React__default.createElement(Typography, { display: "block", variant: "caption", color: "neutral400" },
                React__default.createElement(React__default.Fragment, null, label))))) : (React__default.createElement(Typography, { variant: "body2", color: "neutral400" }, "-")))));
};

export { ChangeIndicator as default };
